<div class="sublet-supplier-dialog flex-column">
  <!-- header -->
  <div class="main-header flex-between-center p-3 border-bottom-lightest">
    <span class="font-18 font-700 color-white">Update sublet supplier</span>
    <div class="flex-row info-section">
      <div class="flex-start-center ro-info">
        <i class="far fa-file-alt"></i>
        <span>{{ roTitle }}</span>
      </div>
      <div class="flex-start-center ro-info">
        <i class="far fa-file-alt"></i>
        <span>RO# {{ code }}</span>
      </div>
      <div class="flex-start-center pointer font-24 font-400 font-gray-65" (click)="handleClose()">
        <i class="far fa-times"></i>
      </div>
    </div>
  </div>

  <!-- body -->
  <div class="main-body" [ngClass]="{ 'flex-center-center': isLoading || !subletGroupsArray?.length }">
    <!-- loop over this for creating islands -->
    <ng-container *ngIf="!isLoading">
      <div class="sublet-detail flex-row mb-3"
        [ngClass]="{ 'width-80p': cartGroup?.groupCategoryStatus === 'unassign' }"
        *ngFor="let cartGroup of subletGroupsArray">
        <div class="flex-column w-100" #subletSupplierBody>
          <div class="flex-column">
            <!-- section main header -->
            <div class="section-main-header border-bottom-lightest">
              <span class="font-14 font-700">Select items and update sublet details</span>
            </div>
            <!-- Drop downs supplier section -->
            <div class="supplier-section mb-0 input-default-style border-bottom-lightest">
              <div class="flex-row gap-63" [ngClass]="{ 'width-80p': cartGroup?.groupCategoryStatus !== 'unassign' }">
                <!-- Supplier -->
                <div class="flex-start-center gap-2 w-100">
                  <i class="fal fa-warehouse font-14"></i>
                  <app-auto-complete class="width-100p" id="sublet-create-supplier" listId="sublet-create-supplier-list"
                    placeholder="Supplier*" label="Supplier*" theme="light" field="name" scrollHeight="180px"
                    editableItemIdKey="_id" [isLoading]="isLoadingSuppliers" vPosition="bottom"
                    editFieldLabel="Create Supplier" [hasStaticUnassignedFiled]="false" [fontSize]="14"
                    [listItemFontSize]="12" [hasFutureSelectionField]="false" [disabled]="false" [floatingLabel]="true"
                    [isDropdownIconVisible]="true" [suggestions]="suppliersResults" [closeOnSelection]="true"
                    [hasEditableField]="true" [isInvalid]="cartGroup?.supplierErrMsg"
                    [hasError]="cartGroup?.supplierErrMsg" [value]="cartGroup?.supplier?.name || ''"
                    (appSelect)="handleChange('supplier', $event, cartGroup)"
                    (appFocus)="showSuggestions(); handleFocus(cartGroup, 'supplierErrMsg')"
                    (appSave)="saveSupplier($event, cartGroup)"
                    (appCompletedMethod)="searchSuggestion($event, 'supplier')"
                    (appUpdateItem)="onUpdateSupplier($event, cartGroup)" (appClickCreate)="scrollToBottom()"
                    (appClear)="onClearSuggestion()">
                    <ng-template let-item let-editItem="editItem" appTemplate="item">
                      <div class="tag-item flex-between-center">
                        <span class="font-14">{{ item?.name }}</span>

                        <div class="tag-item-action flex-end-center">
                          <i class="fas fa-pencil p-1 mr-2" (click)="$event.stopPropagation(); editItem(item)"></i>
                        </div>
                      </div>
                    </ng-template>
                  </app-auto-complete>
                </div>

                <!-- Payment terms -->
                <div class="flex-start-center gap-2 w-100" *ngIf="isAccountPayable">
                  <i class="fal fa-file-invoice-dollar font-14"></i>
                  <app-auto-complete class="width-100p" id="po-payment-term" listId="po-payment-term-list"
                    name="po-pay-term-name" placeholder="Payment terms" label="Payment terms*" theme="light" leftIcon=""
                    scrollHeight="180px" inactiveItemsKey="isActive" styleClassInput="text-ellipse" [fontSize]="13"
                    [disabled]="false" [listItemFontSize]="12" [floatingLabel]="true"
                    [isLoading]="isLoadingPaymentTerms" [isDropdownIconVisible]="true" [suggestions]="paymentTerms"
                    [isInvalid]="cartGroup?.paymentTermErrMsg" [hasError]="cartGroup?.paymentTermErrMsg"
                    [closeOnSelection]="true" [value]="cartGroup?.accPayableTerm?.name || ''"
                    (appFocus)="handleFocus(cartGroup, 'paymentTermErrMsg')"
                    (appSelect)="handleChange('accPayableTerm', $event, cartGroup)"
                    (appCompletedMethod)="searchSuggestion($event, 'accPayableTerm')"
                    (appClickCreate)="scrollToBottom()" (appClear)="onClearSuggestion('accPayableTerm')">
                  </app-auto-complete>
                </div>

                <!-- Notes -->
                <div class="flex-start-center gap-2 w-100">
                  <i class="fal fa-sticky-note font-14"></i>
                  <app-input class="width-100p" id="sublet-notes" type="text" placeholder="Notes" theme="light"
                    [fontSize]="14" name="number" [value]="cartGroup?.notes" [floatingLabel]="true" [maxLength]="50"
                    [disabled]="false" (appChange)="handleChange('notes', $event, cartGroup)">
                  </app-input>
                </div>
              </div>
            </div>
          </div>

          <div class="p-2" *ngFor="let subGroup of cartGroup.subGroups">
            <div class="flex-row br-3 border-lightest">
              <div class="left-section"
                [ngClass]="{ 'left-section': cartGroup?.groupCategoryStatus !== 'unassign', 'w-100': cartGroup?.groupCategoryStatus === 'unassign' }">
                <!-- dates section -->
                <div class="invoice-section border-bottom-lightest">
                  <div class="flex-between-center"
                    *ngIf="['assign', 'paid', 'unpaid', 'sync'].includes(subGroup?.categoryStatus)">
                    <div class="flex-row gap-20">
                      <!-- invoice Date -->
                      <div class="flex-start-center gap-2 font-13">
                        <span class="font-600">Invoice date</span>
                        <p-calendar placeholder="Invoice Date"
                          [styleClass]="subGroup?.invoiceDateErrMsg ? 'sublet-input-field-wrapper-invalid' : 'sublet-input-field-wrapper'"
                          [readonlyInput]="true" appendTo="body"
                          [disabled]="!cartGroup?.accPayableTerm?.name && isAccountPayable"
                          [(ngModel)]="subGroup.invoiceDate" dateFormat="M d, yy"
                          (onSelect)="handleSubGroupChange('invoiceDate', $event, subGroup, cartGroup)"
                          #invDateCalender>
                        </p-calendar>
                      </div>

                      <!-- due date -->
                      <div class="flex-start-center gap-2 font-13" *ngIf="isAccountPayable">
                        <span class="font-600">Due date</span>
                        <p-calendar placeholder="Due Date"
                          [styleClass]="subGroup?.invoiceDateErrMsg ? 'sublet-input-field-wrapper-invalid' : 'sublet-input-field-wrapper'"
                          [readonlyInput]="true" [disabled]="true" appendTo="body" [(ngModel)]="subGroup.dueDate"
                          dateFormat="M d, yy" (onSelect)="handleSubGroupChange('dueDate', $event, subGroup, cartGroup)"
                          #invDateCalender>
                        </p-calendar>
                      </div>

                      <!-- Invoice number -->
                      <div class="flex-start-center gap-2 font-13">
                        <span class="font-600">Invoice#</span>
                        <div class="invoice-number">
                          <app-input type="text" placeholder="Invoice#" theme="border" label="Invoice#" [fontSize]="13"
                            [value]="subGroup?.supplierInvoicedNo" [disabled]="subGroup?.qboId"
                            [isInvalid]="subGroup?.invoiceNoErrMsg" [hasError]="subGroup?.invoiceNoErrMsg"
                            (appFocus)="subGroup.invoiceNoErrMsg = ''"
                            (appChange)="handleSubGroupChange('supplierInvoicedNo', $event, subGroup, cartGroup)">
                          </app-input>
                        </div>
                      </div>
                    </div>

                    <div class="flex-row">
                      <!-- QuickBooks action -->
                      <app-dropdown id="sublet-quickbook" *ngIf="isQboConnected"
                        class="quickbook-sublet-order-dropdown outline-secondary mr-2 font-600"
                        listId="sublet-quickbook-list" field="title" itemWidth="190px"
                        [disabled]="!subGroup?.isAllCompleted || subGroup?.isPosting"
                        [pTooltip]="!subGroup?.isAllCompleted ? 'All items should be marked as completed since we are posting to QBO on cart-level' : ''"
                        tooltipPosition="top" hPosition="left" scrollHeight="150px" [options]="subGroup?.qboOptions"
                        [isDropdownIconVisible]="false" [hasCustomItemTemplate]="true" [hasCustomOpenTemplate]="true"
                        (appSelect)="handleQuickbookAction(cartGroup, subGroup, $event)">
                        <ng-template let-header appTemplate="open-dropdown-btn">
                          <img src="assets/img/icon/qbo-btn-ts.png" *ngIf="!subGroup?.isPosting" class="quickbooks-btn"
                            alt="quickbooks" />
                          <i class="fa fa-spinner rotate" *ngIf="subGroup?.isPosting"></i>
                          <span *ngIf="['paid', 'sync'].includes(subGroup?.categoryStatus)">
                            <span *ngIf="!subGroup.qboId" class="qbo-status-icon not-posted flex-center-center">!</span>
                            <i *ngIf="subGroup?.qboId && subGroup?.isSyncedWithQBO"
                              class="fas fa-check qbo-status-icon synced flex-center-center"></i>
                            <i *ngIf="subGroup?.qboId && !subGroup?.isSyncedWithQBO"
                              class="fas fa-unlink qbo-status-icon not-synced flex-center-center"></i>
                          </span>
                        </ng-template>
                        <ng-template let-item appTemplate="item">
                          <span>{{ item?.title }}</span>
                        </ng-template>
                      </app-dropdown>
                      <button class="btn btn-primary font-14 btn-submit mr-2" *ngIf="subGroup?.paidStatus === 'unpaid'"
                        [ngClass]="{ 'not-allowed': !subGroup?.isSomeCompleted }"
                        [disabled]="!subGroup?.isSomeCompleted || subGroup?.isSubmitting"
                        (click)="markStatus(subGroup, cartGroup, 'paid')"
                        [pTooltip]="!subGroup?.isSomeChecked ? 'please select a sublet item to assign supplier' : !subGroup?.isSomeCompleted ? 'Select completed sublets to mark them as paid' : ''"
                        tooltipPosition="top">
                        Mark paid
                        <i *ngIf="subGroup?.isSubmitting" class="fal fa-spinner rotate ml-2"></i>
                      </button>
                      <button class="btn btn-primary font-14 btn-submit mr-2" *ngIf="subGroup?.paidStatus === 'paid'"
                        (click)="markStatus(subGroup, cartGroup, 'unpaid')"
                        [ngClass]="{ 'not-allowed': !subGroup?.isSomeCompleted || subGroup?.qboId }"
                        [disabled]="!subGroup?.isSomeCompleted || subGroup?.isSubmitting || subGroup?.qboId"
                        [pTooltip]="!subGroup?.isSomeCompleted ? 'Select items to mark unpaid' : ''"
                        tooltipPosition="top">
                        Mark unpaid
                        <i *ngIf="subGroup?.isSubmitting" class="fal fa-spinner rotate ml-2"></i>
                      </button>
                      <button class="btn btn-primary font-14 btn-submit"
                        [ngClass]="{ 'not-allowed': !subGroup?.isSomeChecked }"
                        (click)="updateSubletSubGroup(cartGroup, subGroup)"
                        [disabled]="!subGroup?.isSomeChecked || subGroup?.isUpdating"
                        [pTooltip]="!subGroup?.isSomeChecked ? 'Select items to update' : ''" tooltipPosition="top">
                        Update
                        <i *ngIf="subGroup?.isUpdating" class="fal fa-spinner rotate ml-2"></i>
                      </button>
                    </div>
                  </div>

                  <div class="flex-end-center" *ngIf="subGroup?.categoryStatus === 'unassign'">
                    <button class="btn btn-primary font-14 btn-submit"
                      [ngClass]="{ 'not-allowed': !subGroup?.isSomeChecked }" [disabled]="!subGroup?.isSomeChecked"
                      (click)="assignSupplier(subGroup, cartGroup)">
                      Assign Supplier
                      <i *ngIf="subGroup?.isSubmitting" class="fal fa-spinner rotate ml-2"></i>
                    </button>
                  </div>
                </div>

                <!-- Sublet items section -->
                <div class="sublet-item-section flex-column">
                  <!-- header -->
                  <div class="sublet-item-header flex-row border-bottom-lightest">
                    <!-- select all checkbox -->
                    <span class="ui-g-1">
                      <app-checkbox [isChecked]="subGroup?.isAllChecked"
                        (appChange)="handleSubGroupChange('isAllChecked', $event, subGroup, cartGroup)"></app-checkbox>
                    </span>
                    <span class="ui-g-2 font-14 font-600">Item name</span>
                    <span class="ui-g-2 font-14 font-600">Cost</span>
                    <span class="ui-g-1 font-14 font-600">Price</span>
                    <span class="ui-g-1 font-14 font-600">Taxable</span>
                    <span class="ui-g-1 font-14 font-600">Qty</span>
                    <span *ngIf="isSalesCodeEnabled" class="ui-g-2 font-14 font-600">Sales code</span>
                    <span class="ui-g-1 font-14 font-600">Total cost</span>
                    <span class="ui-g-2 pt-0 font-14 font-600">
                      <div class="mt-1">
                        <app-dropdown id="d-action" listId="d-action-list" field="label" itemWidth="150px"
                          scrollHeight="200px" [options]="assignStatusOptions" [isDropdownIconVisible]="true"
                          [hasCustomOpenTemplate]="true" [selectInactiveItems]="false" [hasCustomItemTemplate]="true"
                          [isCustomizedTemplate]="true"
                          [disabled]="subGroup?.categoryStatus === 'unassign' || subGroup?.qboId || subGroup?.paidStatus === 'paid' || !subGroup?.isAllChecked"
                          [pTooltip]="
                            !subGroup?.isAllChecked
                              ? 'Please select all sublet items to make changes'
                              : subGroup?.categoryStatus === 'unassign'
                                ? 'Please assign supplier to change status'
                                : subGroup?.paidStatus === 'paid' && !subGroup?.qboId
                                  ? 'Please select item and mark it as unpaid to change the status'
                                  : ''
                          " tooltipPosition="top"
                          (appSelect)="handleSubGroupChange('allWorkStatus', $event, subGroup, cartGroup)">
                          <ng-template let-item appTemplate="open-dropdown-btn">
                            <span class="font-14 font-600 w-100">Assign status</span>
                          </ng-template>

                          <ng-template let-item appTemplate="item">
                            <div class="width-100p flex-between-center">
                              <span class="font-14 font-600">{{ item?.label }}</span>
                            </div>
                          </ng-template>
                        </app-dropdown>
                      </div>
                    </span>
                  </div>
                  <!-- body -->
                  <div class="sublet-item-body flex-column">
                    <div class="item-row flex-row border-bottom-lightest"
                      *ngFor="let subletItem of subGroup.subletItems; let subletIndex = index; let subletLast = last">
                      <!-- checkbox -->
                      <span class="ui-g-1">
                        <app-checkbox [isChecked]="subletItem?.isChecked"
                          (appChange)="handleSubletItemChange('isChecked', $event, subletItem, subGroup)"></app-checkbox>
                      </span>
                      <!-- Name -->
                      <span class="ui-g-2 font-14 sublet-description-overflow word-break-breakall">{{ subletItem?.title
                        }}</span>
                      <!-- Cost -->
                      <span class="ui-g-2 font-14 pt-0">
                        <div class="w-50">
                          <app-input styleClassInput="pl-0" placeholder="$0.00" [allowDecimal]="true"
                            [selectTextOnFocus]="true" theme="border" [fontSize]="14"
                            [disabled]="!subletItem?.isChecked"
                            [pTooltip]="!subletItem?.isChecked ? 'Please select a sublet items to make changes' : ''"
                            tooltipPosition="top"
                            [value]="subletItem?.isCostFocus ? subletItem?.cost : (subletItem?.cost || 0 | currency: usd)"
                            (appFocus)="handleInputFocus('isCostFocus', subletItem, true)"
                            (appBlur)="handleInputFocus('isCostFocus', subletItem, false)"
                            (appChange)="handleSubletItemChange('cost', $event, subletItem, subGroup)">
                          </app-input>
                        </div>
                      </span>
                      <!-- Price -->
                      <span class="ui-g-1 font-14">{{ subletItem?.price || 0 | currency: usd }}</span>
                      <!-- taxable -->
                      <span class="ui-g-1 pt-0 font-14">
                        <app-dropdown field="label" styleClassDropdownList="top-38" [setPositionDynamically]="true"
                          theme="light" [disabled]="!subletItem?.isChecked || invoicedRO"
                          [pTooltip]="!subletItem?.isChecked ? 'Please select a sublet items to make changes' : ''"
                          tooltipPosition="top" [fontSize]="14" [hasBorderBottomOnActive]="false" placeholder="Select"
                          [options]="taxableOptions" [setPositionDynamically]="false" [isDropdownIconVisible]="true"
                          [value]="subletItem?.isTaxable ? taxableOptions[0] : taxableOptions[1]"
                          (appSelect)="handleSubletItemChange('isTaxable', $event?.value, subletItem, subGroup)">
                        </app-dropdown>
                      </span>
                      <!-- Quantity -->
                      <span class="ui-g-1 font-14">{{ subletItem?.count }}</span>
                      <!-- sales code -->
                      <span *ngIf="isSalesCodeEnabled" class="ui-g-2 font-14">
                        <app-input id="sales-code-assign" class="w-100" theme="border" placeholder="Sales code"
                          [rightIcon]="!subletItem?.salesCode?.shortName ? 'fas fa-plus-circle font-warning pointer' : ''"
                          [imgIcon]="subletItem?.salesCode?.shortName ? 'assets/img/icon/edit-outline.svg' : ''"
                          imgIconClass="pointer" [floatingLabel]="false" [disabled]="true"
                          [value]="displaySalesCodeTitle(subletItem)"
                          (iconClicked)="openAssignSalesCodeDialog(subletItem)">
                        </app-input>
                      </span>
                      <!-- Total cost -->
                      <span class="ui-g-1 font-14">{{ subletItem?.totalCost || 0 | currency: usd }}</span>
                      <!-- Item status -->
                      <span class="ui-g-2 pt-0 font-14">
                        <app-dropdown field="label" styleClassDropdownList="top-38" [setPositionDynamically]="true"
                          theme="light" [fontSize]="14" [hasBorderBottomOnActive]="false" placeholder="Assign status"
                          [options]="assignStatusOptions" [setPositionDynamically]="false"
                          [isDropdownIconVisible]="true" [pTooltip]="
                            !subletItem?.isChecked
                              ? 'Please select a sublet items to make changes'
                              : subGroup?.categoryStatus === 'unassign'
                                ? 'Please assign supplier to change status'
                                : subGroup?.paidStatus === 'paid' && !subGroup?.qboId
                                  ? 'Please select item and mark it as unpaid to change the status'
                                  : ''
                          " tooltipPosition="top"
                          [disabled]="subGroup?.categoryStatus === 'unassign' || subGroup?.qboId || subGroup?.paidStatus === 'paid' || !subletItem?.isChecked"
                          [value]="subletItem?.workStatus"
                          (appSelect)="handleSubletItemChange('workStatus', $event, subletItem, subGroup)">
                        </app-dropdown>
                      </span>
                    </div>
                  </div>

                  <!-- sublet item footer -->
                  <div class="sublet-item-footer flex-row border-bottom-lightest">
                    <span class="flex-start-center ui-g-4 font-13 font-700">Subtotal </span>
                    <span class="flex-between-center ui-g-2">
                      <span class="p-1 font-13 font-700">{{ subGroup?.cartTotals?.totalCost || 0 | currency: usd
                        }}</span>
                    </span>
                    <span class="flex-start-center ui-g-1 font-13 font-700">{{ subGroup?.cartTotals?.totalPrice || 0 |
                      currency: usd }}</span>
                    <span class="flex-end-center ui-g-2 font-13 font-700"></span>
                    <span class="flex-start-center ui-g-1 font-13 font-700">{{ subGroup?.cartTotals?.grandTotal || 0 |
                      currency: usd }}</span>
                  </div>
                </div>
              </div>
              <div class="right-section p-20p" *ngIf="subGroup?.categoryStatus !== 'unassign'">
                <div class="payment-section flex-column gap-20">
                  <span class="font-14 font-700 font-gray-500">Payment Summary</span>
                  <div class="subtotal-section flex-column gap-2">
                    <div class="flex-between-center font-13 font-700">
                      <span class="pb-2">Subtotal</span>
                      <span class="border-bottom-light pb-2">{{ subGroup?.totals?.subTotal || 0 | currency: usd
                        }}</span>
                    </div>
                    <div class="flex-between-center font-13 font-400">
                      <span class="w-40">{{ subGroup?.totals?.tax?.name }}</span>
                      <span>{{ subGroup?.totals?.taxedAmount || 0 | currency: usd }}</span>
                    </div>
                    <div class="flex-between-center font-13 font-400">
                      <span>Taxable</span>
                      <span>{{ subGroup?.totals?.taxableAmount || 0 | currency: usd }}</span>
                    </div>
                    <div class="flex-between-center font-13 font-400">
                      <span>Non-Taxable</span>
                      <span>{{ subGroup?.totals?.nonTaxableAmount || 0 | currency: usd }}</span>
                    </div>
                    <div class="flex-between-center font-13 font-700">
                      <span class="pt-2 pb-2">Total</span>
                      <span class="font-primary border-top pt-2 pb-2"
                        [ngClass]="{ 'border-bottom-light': subGroup?.paidStatus !== 'paid' }">{{
                        subGroup?.totals?.total || 0 | currency: usd }}</span>
                    </div>
                    <div class="flex-between-center font-13 font-700" *ngIf="subGroup?.paidStatus === 'paid'">
                      <span class="pb-2">Paid Total</span>
                      <span class="pb-2 border-bottom-light">{{ subGroup?.totals?.total || 0 | currency: usd }}</span>
                    </div>
                    <ng-container *ngIf="subGroup?.paidStatus === 'paid' && subGroup.qboId">
                      <div class="flex-between-center font-13 font-400">
                        <span>Invoice date</span>
                        <span>{{ subGroup?.invoiceDate | date: 'MMM d, y' }}</span>
                      </div>
                      <div class="flex-between-center font-13 font-400">
                        <span>Invoice number</span>
                        <span>{{ subGroup?.supplierInvoicedNo }}</span>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="subGroup?.paidStatus === 'paid' && !subGroup.qboId">
                      <div class="flex-start-center pointer gap-1"
                        tooltipStyleClass="sublet-tooltip modifier w-100 border"
                        [pTooltip]="subGroup?.paidDateTimeTooltip" tooltipPosition="left" [escape]="false">
                        <i class="fal fa-money-bill-alt font-12 font-primary-700"></i>
                        <i class="font-12 font-400 font-primary-700">Paid Date &amp; time details</i>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <span *ngIf="isLoading">
      <i class="fal fa-spinner rotate fa-2x font-gray"></i>
    </span>
    <span class="font-gray font-14 font-400" *ngIf="!isLoading && !subletGroupsArray?.length"> No sublet items found.
    </span>
  </div>
</div>
